// extracted by mini-css-extract-plugin
export default {"background":"AlertPopup_background__4zuo9","container":"AlertPopup_container__k5yc-","text":"AlertPopup_text__HsMHF","close_btn":"AlertPopup_close_btn__8coxn"};